import React from "react";

interface PagenationProps {
  currentPage?: number;
  totalPages?: number;
  onPageChange?: (page: number) => void;
}

const Pagenation = ({
  currentPage = 1,
  totalPages = 10,
  onPageChange,
}: PagenationProps) => {

  const handlePageChange = (e: React.MouseEvent, page: number) => {
    e.preventDefault();
    if (page >= 1 && page <= totalPages && onPageChange) {
      onPageChange(page);
    }
  };

  const renderPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 5;
    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <li
          key={i}
          className={`page-item ${currentPage === i ? "active" : ""}`}
        >
          <a
            className="page-link"
            href="#"
            onClick={(e) => handlePageChange(e, i)}
          >
            {i}
          </a>
        </li>,
      );
    }
    return pages;
  };

  const paginationList = (
    <ul className="pagination pagination-dark d-flex justify-content-center pagination-lg mt-4">
      <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
        <a
          className="page-link"
          href="#"
          aria-label="Previous"
          onClick={(e) => handlePageChange(e, currentPage - 1)}
        >
          <span aria-hidden="true">
            <i className="material-symbols-rounded" aria-hidden="true">
              keyboard_double_arrow_left
            </i>
          </span>
        </a>
      </li>
      {renderPageNumbers()}
      <li
        className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
      >
        <a
          className="page-link"
          href="#"
          aria-label="Next"
          onClick={(e) => handlePageChange(e, currentPage + 1)}
        >
          <span aria-hidden="true">
            <i className="material-symbols-rounded" aria-hidden="true">
              keyboard_double_arrow_right
            </i>
          </span>
        </a>
      </li>
    </ul>
  );

  return (
    <>
      <div className="display-max">{paginationList}</div>
      <div className="display-mini display-mob">{paginationList}</div>
    </>
  );
};

export default Pagenation;
